/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useEffect, useRef } from "react";
import { useGLTF, useTexture } from "@react-three/drei";
import { useScroll } from "../../../hooks/use-scroll";
import { mapRange, clamp } from "../../../utils/Maths";
import { useFrame, useThree, useLoader } from "@react-three/fiber";
import { TextureLoader } from "three/src/loaders/TextureLoader";
import { useControls } from "leva";
import CustomChunkFragment from "../CustomChunkFragment.glsl";

import * as THREE from "three";
import { useStore } from "../../../store/store";
import gsap from "gsap";

export function MissDiorOrange(props) {
  const chairRef = useRef();
  const isChairAnimating = useRef(false);
  const orangeColorMap = useLoader(
    TextureLoader,
    "/textures/tdj_orange_diffuse.webp"
  );
  const pinkColorMap = useLoader(
    TextureLoader,
    "/textures/tdj_rose_diffuse.webp"
  );

  const { nodes, materials } = useGLTF("/models/MissDior_TDJ_Orange_CLI.glb");
  const { viewport } = useThree();
  const discoverThreshold = useStore((state) => state.discoverThreshold);
  const displayChair = useStore((state) => state.displayChair);

  const { uMix, color } = useControls({
    uMix: {
      value: 0,
      min: 0,
      max: 1,
      step: 0.01,
      onChange: (v) => {
        // imperatively update the world after Leva input changes
        if (materials.phy_TDj_Orange.userData.uMix) {
          materials.phy_TDj_Orange.userData.uMix.value = v;
        }
      },
    },
  });
  useScroll(({ scroll }) => {
    let progress = mapRange(
      discoverThreshold.start,
      discoverThreshold.end,
      scroll,
      0,
      1
    );
    progress = clamp(0, progress, 1);

    // console.log(progress, discoverThreshold.start, discoverThreshold.end);

    // const half = (discoverThreshold.end - discoverThreshold.start) * 0.5;
    // console.log(progress);
    // console.log(half);

    // const coef =

    let uniformProgress = mapRange(0.4, 0.6, progress, 0, 1);
    uniformProgress = clamp(0, uniformProgress, 1);
    if (materials.phy_TDj_Orange.userData.uMix) {
      materials.phy_TDj_Orange.userData.uMix.value = uniformProgress;
    }

    // console.log(uniformProgress);

    // console.log(discoverThreshold.start, discoverThreshold.end, scroll);
    // chairRef.current.position.x =
    //   viewport.width * positionX - viewport.width * progress;

    // compute default position, chair needs to be out of the screen
    const basePosition = viewport.width * 0.8;

    // final position
    const finalPosition = basePosition + viewport.width;

    // compute travelling position
    // goes from basePosition to basePosition * 2
    const computedPosition = basePosition - finalPosition * progress;

    // chairRef.current.position.x = computedPosition;
    chairRef.current.rotation.y = -Math.PI / 4 + Math.PI * 2 * progress;
  });

  useFrame(({ clock }) => {
    // console.log(clock);
    // chairRef.current.rotation.y = 2 + Math.cos(clock.elapsedTime * 0.1) * 10;
  });

  useEffect(() => {
    orangeColorMap.flipY = false;
    orangeColorMap.encoding = THREE.sRGBEncoding;

    pinkColorMap.flipY = false;
    pinkColorMap.encoding = THREE.sRGBEncoding;

    materials.phy_TDj_Orange.userData.pinkMap = { value: pinkColorMap };
    materials.phy_TDj_Orange.userData.orangeMap = { value: orangeColorMap };
    materials.phy_TDj_Orange.userData.uMix = { value: uMix };

    materials.phy_TDj_Orange.onBeforeCompile = (shader) => {
      shader.uniforms.pinkMap = materials.phy_TDj_Orange.userData.pinkMap;
      shader.uniforms.orangeMap = materials.phy_TDj_Orange.userData.orangeMap;
      shader.uniforms.uMix = materials.phy_TDj_Orange.userData.uMix;

      //prepend the input to the shader
      shader.fragmentShader =
        `
        uniform sampler2D pinkMap;
        uniform sampler2D orangeMap;
        uniform float uMix;

        ` + shader.fragmentShader;

      shader.fragmentShader = shader.fragmentShader.replace(
        "#include <map_fragment>",
        CustomChunkFragment
      );

      // shader.fragmentShader = shader.fragmentShader.replace(
      //   "( map",
      //   "ALLOOOOKFOSKDFODKSFODS;KFKDSLFDLF;DSLF;DL;FLDS;FLDSF;L"
      // );
      // console.log(shader.fragmentShader);
    };

    Object.values(materials).forEach((material) => {
      material.transparent = true;
      material.opacity = 0;
    });

    // materials.phy_TDj_Orange = new THREE.MeshBasicMaterial({
    //   map: orangeColorMap,
    //   color: 0x000000,
    //   opacity: 1
    // });
  }, []);

  useEffect(() => {
    animate(displayChair);
  }, [displayChair]);

  const animate = (direction) => {
    const materialArray = Object.values(materials);

    if (direction === "enter") {
      isChairAnimating.current = true;
      gsap.fromTo(
        chairRef.current.position,
        {
          y: -1.2,
        },
        {
          y: -0.6,
        }
      );
    }

    if (direction === "leaveBack") {
      gsap.fromTo(
        chairRef.current.position,
        {
          y: -0.6,
        },
        {
          y: -1.2,
        }
      );
    }

    if (direction === "enter" || direction === "enterBack") {
      gsap.to(materialArray, {
        opacity: 1,
        duration: 0.25,
      });
    } else if (direction === "leave" || direction === "leaveBack") {
      gsap.to(materialArray, {
        opacity: 0,
        duration: 0.25,
      });
    }
  };

  return (
    <group {...props} ref={chairRef} dispose={null}>
      <mesh geometry={nodes.Pied01.geometry} material={materials.phy_pied} />
      <mesh geometry={nodes.Spacers.geometry} material={materials.phy_alu} />
      <mesh
        geometry={nodes.Armature_MissDior.geometry}
        material={materials.phy_alu}
      />
      <mesh
        geometry={nodes.Piping01.geometry}
        material={materials.Phy_Piping_blanc}
      />
      <mesh
        geometry={nodes.assise_dessous.geometry}
        material={materials.phy_TDj_Orange}
      />
      <mesh
        geometry={nodes.Dossier_arriere.geometry}
        material={materials.phy_TDj_Orange}
      />
      <mesh
        geometry={nodes.Assise.geometry}
        material={materials.phy_TDj_Orange}
      />
      <mesh
        geometry={nodes.Dossier.geometry}
        material={materials.phy_TDj_Orange}
      />
    </group>
  );
}

useGLTF.preload("/models/MissDior_TDJ_Orange_CLI.glb");
